import { cn } from "@/shared/ui/primitives";

/** The Person Learn mark: a path rising from a starting point (curiosity) to a
 * filled destination (mastery). */
export function LogoMark({ className, title = "Person Learn" }: { className?: string; title?: string }) {
  return (
    // With an empty title the mark is decorative (the wordmark text names it).
    <svg viewBox="0 0 64 64" role={title ? "img" : undefined} aria-label={title || undefined}
      aria-hidden={title ? undefined : true} className={cn("size-8", className)}>
      <rect width="64" height="64" rx="15" fill="var(--accent)" />
      <path d="M14 46c7 0 10-6 14-12s8-12 16-12" fill="none" stroke="var(--accent-ink)" strokeWidth="5"
        strokeLinecap="round" />
      <circle cx="14" cy="46" r="4" fill="var(--accent-ink)" fillOpacity="0.55" />
      <circle cx="47" cy="21" r="6" fill="var(--accent-ink)" />
    </svg>
  );
}

export function Wordmark({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <LogoMark className={compact ? "size-7" : "size-8"} title="" />
      <span className="text-[17px] font-semibold tracking-[-0.01em] text-ink">Person Learn</span>
    </span>
  );
}

export const TAGLINE = "Your learning. Your journey.";
export const BRAND_STATEMENT = "Personalized learning, from curiosity to mastery.";
